// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"97db93a5","453":"03a1a630"}[chunkId] + ".chunk.js";
};